import api from './api';
import type { TagRecetaAPI } from './recetasAPI';

/**
 * Cliente API para el catálogo de tags de receta.
 * Endpoint: GET /api/tags-receta (definido en routes/tagsReceta.ts).
 */
export const tagsRecetaAPI = {
  async listar(): Promise<TagRecetaAPI[]> {
    const response = await api.get<{ success: boolean; data: TagRecetaAPI[] }>(
      '/tags-receta'
    );
    return response.data.data;
  },
};

export type { TagRecetaAPI };
